<template>
    <div>
        <dialog ref="dialog" class="calendar-popup" id="calendar-popup">
            <div class="calendar-popup__inner">
                <button
                    class="calendar-popup__close"
                    type="button"
                    data-dialog-close
                    @click="closeDialog"
                >
                    <span class="visually-hidden">Close</span>
                    <Icon name="close-circle" />
                </button>

                <div class="calendar-popup-item" v-if="openEvent">
                    <div class="calendar-popup-item__inner">
                        <div
                            v-if="openEvent.image"
                            class="calendar-popup-item__media"
                        >
                            <a class="calendar-popup-item__image-link" :href="openEvent.event?.url">
                                <div class="calendar-popup-item__intrinsic-ratio">
                                    <img
                                        class="calendar-popup-item__image"
                                        :srcset="`
                                            ${openEvent.image.src}?w=300&h=225 300w,
                                            ${openEvent.image.src}?w=410&h=308 410w,
                                            ${openEvent.image.src}?w=600&h=450 600w,
                                            ${openEvent.image.src}?w=820&h=615 820w
                                        `"
                                        sizes="(max-width: 512px) 300px, 410px"
                                        :src="openEvent.image.src"
                                        width="410"
                                        height="228"
                                        :alt="openEvent.image.alt || openEvent.image.caption || openEvent.title"
                                        loading="lazy"
                                    />
                                </div>
                            </a>
                        </div>

                        <div class="calendar-popup-item__performance">
                            <div class="calendar-popup-item__header">
                                <!-- Left empty for aspect ratio -->
                            </div>

                            <div class="calendar-popup-item__body">
                                <div class="calendar-popup-item__titles">
                                    <span
                                        v-if="openEvent.prefix"
                                        class="calendar-popup-item__prefix"
                                        >{{ openEvent.prefix }}
                                    </span>

                                    <h2 class="calendar-popup-item__title" v-html="openEvent.title" />

                                    <span
                                        v-if="openEvent.suffix"
                                        class="calendar-popup-item__suffix"
                                        >{{ openEvent.suffix }}
                                    </span>
                                </div>

                                <div class="calendar-popup-item__meta">
                                    <p class="calendar-popup-item__time" v-if="!openEvent.hideStartTime">
                                        {{ openEvent.formattedTime }}
                                    </p>

                                    <p
                                        class="calendar-popup-item__venue"
                                        v-if="openEvent.venue"
                                    >
                                        {{ openEvent.venue.title }}
                                    </p>
                                </div>

                                <ul
                                    v-if="openEvent.attributes?.custom?.tags && openEvent.attributes.custom.tags.length"
                                    class="calendar-popup-item__tags"
                                >
                                    <li
                                        v-for="tag in openEvent.attributes.custom.tags"
                                        :key="tag"
                                        class="calendar-popup-item__tag"
                                    >
                                        {{ tag }}
                                    </li>
                                </ul>

                                <div v-if="openEvent.attributes?.custom?.post_show_panel">
                                    <calendar-info :event="openEvent" />
                                </div>

                                <div
                                    class="calendar-popup-item__info"
                                    v-if="openEvent.additional_info?.approximate_running_time || openEvent.additional_info?.recommended_age"
                                >
                                    <p v-if="openEvent.additional_info?.approximate_running_time" class="calendar-popup-item__duration"><strong>Approximate Running Time</strong>: {{ openEvent.additional_info.approximate_running_time }}</p>
                                    <p v-if="openEvent.additional_info?.recommended_age" class="calendar-popup-item__age"><strong>Recommended Age</strong>: {{ openEvent.additional_info.recommended_age }}</p>
                                </div>

                                <div
                                    class="calendar-popup-item__description"
                                    v-if="openEvent.description"
                                    v-html="openEvent.description"
                                ></div>
                            </div>

                            <div
                                class="calendar-popup-item__footer"
                                v-if="openEvent.ctaPrimary || openEvent.ctaSecondary"
                            >
                                <a
                                    v-if="openEvent.ctaSecondary"
                                    :href="openEvent.ctaSecondary.link"
                                    class="calendar-popup-item__read-more btn btn--small btn--outline-primary"
                                >
                                    More Info
                                </a>
                                <a
                                    v-if="openEvent.ctaPrimary"
                                    :href="openEvent.ctaPrimary.link"
                                    class="calendar-popup-item__btn btn btn--small"
                                >
                                    {{ openEvent.ctaPrimary.title }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script setup>
import { format } from 'date-fns';
import { computed, inject, ref, watch } from 'vue';
import Icon from '../../js/components/Icon.vue';
import CalendarInfo from './calendar-info.vue';
import { setState, useState } from '../services/stateful';

const emit = defineEmits(['close']);

const imageUrl = inject('imageUrl');
const dialog = ref(null);
const openEvent = useState('calendar-popup.open-event', null);

const formattedDate = computed(() => {
    if (openEvent && Object.keys(openEvent).length) {
        return format(openEvent.performancedate, 'EEE, MMM d');
    }
});

const closeDialog = () => {
    setState('calendar-popup.open-event', null);
};

watch(openEvent, (newEvent) => {
    if (newEvent === null) {
        dialog.value.close();
        emit('close');
    } else {
        dialog.value.showModal();
    }
});

defineExpose({
    closeDialog
});
</script>
